import React, { useEffect, useMemo, useState } from "react";
import { FaXmark } from "react-icons/fa6";
import ExpandableComponent from "../../components/BasicComponents/ExpandableComponent";
import { FaUpload } from "react-icons/fa";
import { AiOutlinePaperClip } from "react-icons/ai";
import ToggleButtonComp from "../../components/BasicComponents/ToggleButtonComp";
import { useGetuploadCsvMutation } from "./sql/TablesourceApiSlice";
import SelectBox from "../reduxworkbook/components/Aside2Components/DropzoneComponents/FilterConfigCompComponents/SelectBox";

const delimiterOptions = [
  { label: `Comma ","`, value: "comma" },
  { label: `Semicolon ";"`, value: "semicolon" },
  { label: `Tab "t"`, value: "tab" }, // Explicitly mention it
  { label: `Pipe "|"`, value: "pipe" },
];
const tableAlreadyExistsOptions = [
  { label: "Fail", value: "fail" },
  { label: "Replace", value: "replace" },
  { label: "Append", value: "append" },
];
const nullValueOptions = [
  { label: "Empty String", value: "emptyString" },
  { label: "None", value: "none" },
  { label: "nan", value: "nan" },
  { label: "null", value: "null" },
  { label: "N/A", value: "n/a" },
];
const toggleOptions = [
  {
    id: "skipSpaces",
    title: "Skip spaces after delimiter",
    defaultValue: false,
  },
  {
    id: "skipBlankLines",
    title:
      "Skip blank lines rather than interpreting them as Not A Number value",
    defaultValue: false,
  },
  {
    id: "dateFormat",
    title: "DD/MM format dates, international and European format",
    defaultValue: false,
  },
];

const numberInputs = [
  { label: "Header Row", id: "headerRow", defaultValue: 0 },
  { label: "Rows to Read", id: "rowsToRead", defaultValue: 0 },
  { label: "Skip Rows", id: "skipRows", defaultValue: 0 },
];

export default function UploadCSV({ closeModal }) {
  const [
    getuploadCsv,
    { data: csvUploadedData, isLoading, isSuccess, isError, error },
  ] = useGetuploadCsvMutation();
  if (isLoading) {
    console.log("uploading...");
  }
  if (isError) {
    console.log(error);
  }
  if (isSuccess) {
    console.log(csvUploadedData);
  }
  const [file, setFile] = useState(null);
  const [fileName, setFileName] = useState(null);
  console.log(file);
  console.log(fileName);

  const [tableName, setTableName] = useState("");
  const [decimalCharacter, setDecimalCharacter] = useState(".");
  const [delimeter, setDelimeter] = useState(delimiterOptions[0].value);
  const [tableAlreadyExist, settableAlreadyExist] = useState(
    tableAlreadyExistsOptions[0].value
  );
  const [nullValue, setNullValue] = useState(nullValueOptions[3].value);
  const initialToggleState = useMemo(() => {
    return toggleOptions.reduce(
      (acc, option) => ({ ...acc, [option.id]: false }),
      {}
    );
  }, []);

  const [toggleStates, setToggleStates] = useState(initialToggleState);
  const [rowSectionValues, setRowSeactionValues] = useState(
    numberInputs.reduce(
      (acc, option) => ({ ...acc, [option.id]: option.defaultValue }),
      {}
    )
  );
  let uploadDetails = {
    tableName: tableName !== "" ? tableName : "",
    decimalCharacter: decimalCharacter,
    delimeter: delimeter,
    tableAlreadyExist: tableAlreadyExist,
    nullValue: nullValue,
    toggleStates: toggleStates,
    rowSectionValues: rowSectionValues,
  };
  // useEffect(() => {
  // }, [
  //   filesDetails,
  //   tableName,
  //   decimalCharacter,
  //   delimeter,
  //   tableAlreadyExist,
  //   nullValue,
  //   toggleStates,
  //   rowSectionValues,
  // ]);
  console.log(uploadDetails);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    console.log(file);
    if (file) {
      setFile(file);
      setFileName(file.name);
    }
  };
  const handleTableName = (e) => {
    const tableName = e.target.value;
    setTableName(tableName);
  };
  const handleDecimalCharacter = (e) => {
    const tableName = e.target.value;
    setDecimalCharacter(tableName);
  };
  const handleDelimeter = (e) => {
    const option = e.target.value;
    setDelimeter(option);
  };
  const handleAlreadyExist = (e) => {
    const option = e.target.value;
    settableAlreadyExist(option);
  };
  const handleNullValue = (e) => {
    const option = e.target.value;
    setNullValue(option);
  };
  const handleToggleValue = (id, value) => {
    setToggleStates((prev) => ({ ...prev, [id]: value }));
  };
  const handleRowSection = (id, value) => {
    setRowSeactionValues((prev) => ({ ...prev, [id]: Number(value) }));
  };
  const handleUpload = async () => {
    if (file && uploadDetails) {
      const formData = new FormData();
      formData.append("file", file);
      formData.append("tableName", uploadDetails.tableName);
      formData.append("decimalCharacter", uploadDetails.decimalCharacter);
      formData.append("delimeter", uploadDetails.delimeter);
      formData.append("tableAlreadyExist", uploadDetails.tableAlreadyExist);
      formData.append("nullValue", uploadDetails.nullValue);
      formData.append("toggleStates", uploadDetails.toggleStates);
      formData.append("rowSectionValues", uploadDetails.rowSectionValues);
      console.log(formData);
      getuploadCsv({
        formData,
      });
    }
  };
  const handleKeyDown = (event) => {
    if (event.ctrlKey && event.key === "Enter") {
      handleUpload(); // Call your function here
    }
  };
  return (
    <main
      className="fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-50 z-50"
      onKeyDown={handleKeyDown}
    >
      <main className="h-auto max-h-[90%] w-[35%] bg-white flex flex-col shadow-xl gap-2 min-w-[35%] rounded">
        <header className="p-2 flex items-center justify-between rounded-t-lg bg-gray-50 font-medium tracking-wide">
          CSV Upload
          <button>
            <FaXmark onClick={closeModal} />
          </button>
        </header>
        <main className="h-[30rem] flex flex-col px-2 items-start justify-start w-full overflow-hidden overflow-y-auto">
          <ExpandableComponent
            Title="General Information"
            SubTitle="Upload a file to a database"
            defaultValue={true}
          >
            {/* file */}
            <div className="w-full items-start justify-start flex gap-2 p-1">
              <label
                htmlFor="fileInput"
                className="flex items-center gap-2 px-2 py-[2px] bg-blue-950 text-white rounded cursor-pointer"
              >
                <FaUpload />
                select
              </label>
              <input
                type="file"
                id="fileInput"
                onChange={handleFileChange}
                accept=".csv"
                className="hidden" // Hide default file input
              />
              {fileName !== null ? (
                <button className="text-gray-800 text-sm flex w-auto hover:bg-gray-100 items-center gap-1 p-[2px] rounded">
                  <AiOutlinePaperClip />
                  {fileName}
                </button>
              ) : null}
            </div>
            {/* table name */}
            <div className="w-full p-1 flex flex-col gap-1">
              <label className="font-medium">Table Name</label>
              <input
                type="text"
                placeholder="name of table to be created"
                value={tableName}
                onChange={handleTableName}
                className="border border-gray-200 rounded focus:outline-none p-1"
              />
            </div>
            {/* delimater */}
            <div className="w-full p-1 flex flex-col gap-1">
              <label className="font-medium">Delimeter</label>
              <SelectBox
                value={delimeter}
                onChange={handleDelimeter}
                optionsArray={delimiterOptions}
                isArrayBig={delimiterOptions.length > 6}
              />
            </div>
          </ExpandableComponent>
          <ExpandableComponent
            Title={`File Setting`}
            SubTitle={`Adjust how spaces, blank lines, null values are handled and other file wide settings.`}
            defaultValue={false}
          >
            {/* alredy exist */}
            <div className="w-full p-1 flex flex-col gap-1">
              <label className="font-medium">If Table Already Exists</label>
              <SelectBox
                value={tableAlreadyExist}
                onChange={handleAlreadyExist}
                optionsArray={tableAlreadyExistsOptions}
                isArrayBig={tableAlreadyExistsOptions.length > 6}
              />
            </div>
            {/* decimal character */}
            <div className="w-full p-1 flex flex-col gap-1">
              <label className="font-medium">Decimal Character</label>
              <input
                type="text"
                placeholder="name of table to be created"
                value={decimalCharacter}
                onChange={handleDecimalCharacter}
                className="border border-gray-200 rounded focus:outline-none p-1"
              />
            </div>
            {/* null values */}
            <div className="w-full p-1 flex flex-col gap-1">
              <label className="font-medium">Null Values</label>
              <SelectBox
                value={nullValue}
                onChange={handleNullValue}
                optionsArray={nullValueOptions}
                isArrayBig={nullValueOptions.length > 6}
              />
            </div>
            {toggleOptions.map((option) => (
              <ToggleButtonComp
                key={option.id}
                defaultValue={option.defaultValue}
                setToggleValue={(value) => handleToggleValue(option.id, value)}
                id={option.id}
                toggleValue={toggleStates[option.id]}
                toggleButtonCompTitle={option.title}
              />
            ))}
          </ExpandableComponent>
          <ExpandableComponent
            Title={`Rows`}
            SubTitle={`Set header rows and number of rows to read or skip`}
            defaultValue={false}
          >
            <div className="w-full flex items-center justify-between ">
              {numberInputs.map((option) => (
                <div className="w-[30%] p-1 flex flex-col gap-1">
                  <label className="font-medium">{option.label}</label>
                  <input
                    type="number"
                    id={option.id}
                    placeholder="name of table to be created"
                    value={rowSectionValues[option.id] || option.defaultValue}
                    onChange={(e) =>
                      handleRowSection(option.id, e.target.value)
                    } // Corrected
                    className="border border-gray-200 rounded focus:outline-none p-1"
                  />
                </div>
              ))}
            </div>
          </ExpandableComponent>
        </main>
        <footer className="w-full items-center justify-end flex gap-4 p-2">
          {isError ? (
            <p className="text-red-500 font-medium">{"error"}</p>
          ) : null}
          {isSuccess && (
            <div className="text-green-500 font-medium">
              File uploaded successfully!
            </div>
          )}
          <button
            className="border tracking-wide px-6 text-center py-[3px]"
            onClick={closeModal}
          >
            Cancel
          </button>
          <button
            className="border tracking-wide px-6 text-center py-[3px] bg-blue-950 text-white"
            onClick={handleUpload}
          >
            {isLoading ? "Uploading..." : "Upload"}
          </button>
        </footer>
      </main>
    </main>
  );
}
